import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions';
import './DiagnosticsPromoBox.scss';
import get from 'lodash/get';
import lodashIsEmpty from 'lodash/isEmpty';

class DiagnosticsPromoBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      diagnosticsPromocode: '',
      isApplied: false,
      message: '',
      loading: false,
    };
  }

  componentDidMount() {
    const { promotionDetails } = this.props;
    if (!lodashIsEmpty(promotionDetails)) {
      const code = get(promotionDetails, 'code') || '';
      const isValid = get(promotionDetails, 'is_valid') || '';
      const message = get(promotionDetails, 'message') || '';

      this.setState({
        diagnosticsPromocode: isValid ? code : '',
        isApplied: Boolean(isValid),
        message,
      });

      if (isValid) {
        this.props.actions.setDiagnosticsPromocode(promotionDetails);
      }
    }
  }

  removediagnosticsPromocode = () => {
    this.props.actions.resetDiagnosticsPromocode();
    this.setState({
      diagnosticsPromocode: '',
      isApplied: false,
      message: '',
      loading: false,
    });
  };

  applydiagnosticsPromocode = () => {
    const { diagnosticsPromocode, loading } = this.state;
    if (loading) {
      return;
    }
    if (!diagnosticsPromocode || diagnosticsPromocode.length < 3) {
      this.setState({
        message: 'Invalid Code!',
        isApplied: false,
      });
      return;
    }

    this.setState({ loading: true });

    this.props.actions
      .getDiagnosticsCart({ promocode: diagnosticsPromocode })
      .then(response => {
        const { status, data: { promo_code_details } = {}, error } = response;

        if (status === 0) {
          throw new Error({ message: get(error, 'message.errorText', '') });
        }

        const { message, code, is_valid } = promo_code_details;

        if (is_valid) {
          this.props.actions.setDiagnosticsPromocode(promo_code_details);
        }

        this.setState({
          diagnosticsPromocode: is_valid ? code : '',
          isApplied: Boolean(is_valid),
          message,
          loading: false,
        });
      })
      .catch(({ message }) => {
        this.setState({
          diagnosticsPromocode: '',
          isApplied: false,
          message,
          loading: false,
        });
      });
  };

  render() {
    const { diagnosticsPromocode, message, isApplied, loading } = this.state;
    return (
      <div className="DiagnosticsPromoBoxContainer">
        <div className="InputContainer">
          <input
            type="text"
            name="DiagnosticsPromoBox"
            tabIndex={-2}
            value={diagnosticsPromocode}
            placeholder="Enter promocode here"
            disabled={isApplied}
            onChange={e =>
              this.setState({
                diagnosticsPromocode: e.target.value,
                message: '',
              })
            }
            onKeyPress={e =>
              e.which === 13 ? this.applydiagnosticsPromocode() : null
            }
          />
          <button
            className={loading ? 'loading' : ''}
            onClick={() =>
              isApplied
                ? this.removediagnosticsPromocode()
                : this.applydiagnosticsPromocode()
            }
          >
            {isApplied ? 'REMOVE' : 'APPLY'}
          </button>
        </div>
        {isApplied ? (
          <div className="SuccessText">{message}</div>
        ) : (
          <div className="ErrorText">{message}</div>
        )}
      </div>
    );
  }
}

DiagnosticsPromoBox.propTypes = {
  // diagnosticsPromocode: PropTypes.object,
  actions: PropTypes.object,
  promotionDetails: PropTypes.object.isRequired,
};

DiagnosticsPromoBox.defaultProps = {
  // diagnosticsPromocode: {},
  actions: {},
};

export default connect(
  state => ({
    promotionDetails:
      get(state.diagnosticsCart, 'data.promo_code_details') || {},
    // diagnosticsPromocode: state.order.diagnosticsPromocode
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  })
)(DiagnosticsPromoBox);
